import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, Button, TextField, Tabs, Tab } from '@mui/material';

export default function AntifraudPage() {
  const [alerts, setAlerts] = useState([]);
  const [tab, setTab] = useState('pending');
  const [stats, setStats] = useState({pending:0, approved:0, rejected:0, auto_blocked:0, all:0});
  const [notes, setNotes] = useState({});
  const [msg, setMsg] = useState('');
  const tok = localStorage.getItem('dashboard_token');

  const load = () => {
    fetch('/api/antifraud/alerts?status='+tab, { headers:{ Authorization:'Bearer '+tok } })
      .then(r=>r.json()).then(d=>setAlerts(d || []));
    fetch('/api/antifraud/stats', { headers:{ Authorization:'Bearer '+tok } })
      .then(r=>r.json()).then(d=>setStats(d || {pending:0,approved:0,rejected:0,auto_blocked:0,all:0}));
  };
  useEffect(() => { load(); }, [tab]);

  const decide = async (id, action) => {
    const note = notes[id] || '';
    const r = await fetch(`/api/antifraud/${id}/decide?decision=${action}&note=${encodeURIComponent(note)}`, {
      method:'POST', headers:{ Authorization:'Bearer '+tok }
    });
    if(r.ok){ setMsg('✅ Виконано'); setTimeout(()=>setMsg(''),3000); load(); }
  };

  const del = async (id) => {
    if(!window.confirm('Видалити алерт?')) return;
    await fetch('/api/antifraud/'+id, { method:'DELETE', headers:{ Authorization:'Bearer '+tok } });
    setMsg('🗑 Видалено'); setTimeout(()=>setMsg(''),3000); load();
  };

  const sevColor = (s) => s==='high'?'#f44':s==='medium'?'#ff9800':'#4caf50';
  const sevLabel = (s) => s==='high'?'🔴 ВИСОКИЙ':s==='medium'?'🟡 СЕРЕДНІЙ':'🟢 НИЗЬКИЙ';

  return (
    <Box sx={{p:3}}>
      <Typography variant="h5" sx={{color:'#FFD700',mb:3}}>🛡 Антифрод</Typography>

      <Tabs value={tab} onChange={(e,v)=>setTab(v)} sx={{mb:2,'& .MuiTab-root':{color:'#aaa'},'& .Mui-selected':{color:'#FFD700'}}}>
        <Tab value="pending" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>⏳ Очікують</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.pending}</Typography></Box>}/>
        <Tab value="approved" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>✅ Розблоковані</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.approved}</Typography></Box>}/>
        <Tab value="rejected" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>❌ Відхилені</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.rejected}</Typography></Box>}/>
        <Tab value="auto_blocked" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>🚫 Заблоковані</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.auto_blocked}</Typography></Box>}/>
        <Tab value="all" label={<Box sx={{textAlign:'center'}}><Typography sx={{fontSize:13}}>📋 Всі</Typography><Typography sx={{fontSize:11,color:'#999'}}>{stats.all}</Typography></Box>}/>
      </Tabs>

      {msg && <Typography sx={{color:'#4caf50',mb:2}}>{msg}</Typography>}

      {alerts.length === 0 ? (
        <Paper sx={{bgcolor:'#1a1a2e',p:3,textAlign:'center',color:'#aaa'}}>Немає алертів</Paper>
      ) : alerts.map(a => (
        <Paper key={a.id} sx={{bgcolor:'#1a1a2e',border:'2px solid '+sevColor(a.severity),p:2,mb:2}}>
          <Box sx={{display:'flex',justifyContent:'space-between',mb:1,flexWrap:'wrap'}}>
            <Box>
              <Typography sx={{color:sevColor(a.severity),fontSize:13,fontWeight:'bold'}}>{sevLabel(a.severity)} | Confidence: {a.confidence}%</Typography>
              <Typography sx={{color:'#FFD700',fontSize:14,mt:0.5}}>🔍 {a.alert_type}</Typography>
            </Box>
            <Typography sx={{color:'#aaa',fontSize:11}}>{new Date(a.created_at).toLocaleString()}</Typography>
          </Box>

          <Paper sx={{bgcolor:'#0a0a0a',p:1.5,my:1}}>
            <Typography sx={{color:'#fff',fontSize:13}}>📝 {a.description}</Typography>
            {a.telegram_id && <Typography sx={{color:'#aaa',fontSize:12,mt:0.5}}>👤 Telegram ID: {a.telegram_id}</Typography>}
          </Paper>

          {a.status === 'pending' && (
            <Box>
              <TextField fullWidth size="small" placeholder="Нотатка адміна..." value={notes[a.id]||''}
                onChange={e=>setNotes({...notes,[a.id]:e.target.value})}
                sx={{mb:1,'& input':{color:'#fff'},'& .MuiOutlinedInput-notchedOutline':{borderColor:'#555'}}}/>
              <Box sx={{display:'flex',gap:1,flexWrap:'wrap'}}>
                <Button variant="contained" onClick={()=>decide(a.id,'approve')} sx={{bgcolor:'#4caf50'}}>✅ Розблокувати</Button>
                <Button variant="outlined" onClick={()=>decide(a.id,'block')} sx={{borderColor:'#f44',color:'#f44'}}>🚫 Заблокувати</Button>
                <Button variant="outlined" onClick={()=>decide(a.id,'unblock')} sx={{borderColor:'#aaa',color:'#aaa'}}>👁 Залишити під наглядом</Button>
              </Box>
            </Box>
          )}
          <Box sx={{display:'flex',gap:1,mt:1,justifyContent:'flex-end'}}>
            <Button size="small" onClick={()=>del(a.id)} sx={{color:'#f44'}} variant="outlined">🗑</Button>
          </Box>
        </Paper>
      ))}
    </Box>
  );
}
